import React from 'react'
import { Badge } from '@chakra-ui/react'

export default (props) => {
  return <Badge {...props} />
}
